exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pictrue[data-v-4f09880c] {\r\n  border: none;\n}\r\n", ""]);

// exports
